/* 
 * Solution.js
 * 
 * @author Olivier van der Pool for Ranj
 */

export default class Solution {
    constructor() {
        this._id = "";
        this._description = "";
        this._supportingArguments = [];
        this.isCorrect = false;
        this._feedbackLabel = "";
        this._feedbackDescription = "";
    }

    getID() {
        return this._id;
    }

    setID(value) {
        this._id = value;
    }

    getDescription() {
        return this._description;
    }

    setDescription(value) {
        this._description = value;
    }

    getFeedbackDescription() {
        return this._feedbackDescription;
    }

    setFeedbackDescription(value) {
        this._feedbackDescription = value;
    }

    getFeedbackLabel() {
        return this._feedbackLabel;
    }

    setFeedbackLabel(value) {
        this._feedbackLabel = value;
    }

    getArguments() {
        return this._supportingArguments;
    }

    addArgument(argument) {
        this._supportingArguments.push(argument);
    }

    getArgumentByID(id) {
        for (let i = 0; i < this._supportingArguments.length; i++) {
            if (this._supportingArguments[i].getID() === id) {
                return this._supportingArguments[i];
            }
        }
        return null;
    }

    isArgumentCorrect(argumentid) {
        const argument = this.getArgumentByID(argumentid);
        return argument !== null;
    }
}